module.exports = __webpack_public_path__ + "img/custom-channel-post.a3e86290.png";